<template>
<div>
  <RedeemPlatelistModal />

  <div :class="['plan-detail', { 'screen-lg': onTabletUp }]">
    <!-- TODO: Use the Hero Component -->
    <div class="detail-hero" :style="`backgroundImage: url(${hasDays ? platelist.platelistImage : days.image}`">
      <div class="date-select-wrapper">
        <!-- <div v-if="numberOfWeeks > 1" class="date-select">
          <span @click="prevWeek">
            <BaseIcon class="date-selec-icon" name="chevron-left" />
          </span>
          <h4>{{ $t('lblWeek') }} {{ currentWeekOffset }}</h4>
          <span @click="nextWeek">
            <BaseIcon class="date-selec-icon" name="chevron-right" />
          </span>
        </div> -->
      </div>

      <div class="tag-wrapper">
        <div class="tag" v-if="hasDays"> <img class="icon-cloche" src="@assets/images/icon-cloche.png" /> {{ numberOfDishes }} {{ $t('lblDishes') }} </div>
        <div class="tag" v-if="hasDays"> <img class="icon-calendar" src="@assets/images/icon-calendar.png" /> {{ days.length }} {{ $t('lblDay') }} </div>
      </div>
    </div>

    <div class="detail-content-container">
      <div class="detail-header" v-if="hasDays">
        <h1>{{ platelist.landingpagetitle }}</h1>
        <p>{{ platelist.landingpagedescription }}</p>
      </div>

      <!-- TODO: Hide Share Button, pending Branch link refinement -->
      <!-- <div class="share-btn-wrapper">
        <BaseButton type="button" class="btn-small btn-share" @click="this.share">Share</BaseButton>
      </div> -->

      <div class="detail-section" v-for="(day, i) in days" :key="day.id" v-if="hasDays">
        <h3 class="section-title" v-if="dayHasDishes(day)">
          {{ day.headerValue }}
          <small>
            {{ $t('lblCalories') }} {{ formattedMacro(day, 'calories').unit }} • {{ $t('lblCarbs') }} {{ formattedMacro(day, 'carbs').unit }} •
            {{ $t('lblProtien') }} {{ formattedMacro(day, 'protein').unit }} • {{ $t('lblFat') }} {{ formattedMacro(day, 'fat').unit }}
          </small>
        </h3>

        <div v-for="dish in dishes(day)" v-if="dayHasDishes(day)">
          <div class="mealtime-section" v-if="dish[0].mealtime === 'Breakfast'">
            <h4>{{ $t('lblMorning') }}</h4>
            <MealCardHorizontal v-for="(dishData, i) in dish[1]" :key="i" :dish="dishData" :platelistLockStatus="platelist.contentLockStatus" />
          </div>

          <div class="mealtime-section" v-if="dish[0].mealtime === 'Lunch'">
            <h4>{{ $t('lblAfternoon') }}</h4>
            <MealCardHorizontal v-for="(dishData, i) in dish[1]" :key="i" :dish="dishData" :platelistLockStatus="platelist.contentLockStatus" />
          </div>

          <div class="mealtime-section" v-if="dish[0].mealtime === 'Dinner'">
            <h4>{{ $t('lblEvening') }}</h4>
            <MealCardHorizontal v-for="(dishData, i) in dish[1]" :key="i" :dish="dishData" :platelistLockStatus="platelist.contentLockStatus" />
          </div>
        </div>
      </div>

      <div class="notice-ended" v-if="!hasDays">
        <h2>{{ days.title }}</h2>
        <p>{{ days.body }}</p>
        <BaseButton type="button" @click="toPlans">
          {{ days.ctaText }}
        </BaseButton>
      </div>
    </div>
  </div>

  <transition name="fade">
    <BaseButton class="btn-start-plan" type="button" @click="applyPlatelistToPlan" v-if="hasDays && !drawerTransitioning && isOpen">
      <span v-if="isPlatelistLocked">{{ $t('lblUnlock') }}</span>
      <span v-else>{{ $t('plans.btnStartPlan') }}</span>
    </BaseButton>
  </transition>
</div>
</template>

<script>
import store from '@state/store';
import MealCardHorizontal from '../MealCard/MealCardHorizontal';
import RedeemPlatelistModal from '../Modals/RedeemPlatelistModal.vue';
import { macrosMixin } from 'macrosMixin';
import utils from '@src/utils/utils';
import Leanplum from 'leanplum-sdk';
import {
  errorsComputed,
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  mainComputed,
  mainMethods,
  planComputed,
  planMethods,
  platelistComputed,
  platelistMethods,
  primaryNavComputed,
  primaryNavMethods,
  shareMethods,
} from '@state/helpers';

export default {
  mixins: [macrosMixin],
  components: {
    MealCardHorizontal,
    RedeemPlatelistModal,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      numberOfWeeks: 0,
      numberOfDishes: 0,
      currentWeekOffset: 1,
      componentKey: 0,
    };
  },
  computed: {
    ...errorsComputed,
    ...mainComputed,
    ...platelistComputed,
    ...planComputed,
    ...kitchenDrawerComputed,
    ...primaryNavComputed,
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
    platelist() {
      return this.data;
    },
    days() {
      if (this.platelistDays && this.platelistDays.length && this.platelistDays[this.platelist.id].length > 0) {
        const daysSubset = this.platelistDays[this.platelist.id].filter((day) => {
          return day.dateOffset >= 7 * (this.currentWeekOffset - 1) && day.dateOffset < 7 * this.currentWeekOffset;
        });
        return daysSubset;
      } else {
        return this.platelistDays[this.platelist.id];
      }
    },
    hasDays() {
      return this.days.length > 0 ? true : false;
    },
    isPlatelistLocked() {
      return (
        this.selectedPlatelist &&
        this.selectedPlatelist.contentLockStatus &&
        this.selectedPlatelist.contentLockStatus.locked &&
        !this.selectedPlatelist.contentLockStatus.unlockDate
      );
    },
  },
  beforeMount() {
    this.setSelectedPlatelist(this.data);
  },
  mounted() {
    const platelistDetailDays = this.platelistDays[this.platelist.id];

    if (platelistDetailDays.length > 0) {
      this.numberOfWeeks = Math.ceil((platelistDetailDays[platelistDetailDays.length - 1].dateOffset + 1) / 7);
      this.numberOfDishes = 0;

      this.days.forEach((day) => {
        this.numberOfDishes += day.meals.length + day.recipes.length;
      });
    }
  },
  destroyed() {
    this.setSelectedPlatelist(null);
  },
  methods: {
    ...kitchenDrawerMethods,
    ...mainMethods,
    ...planMethods,
    ...platelistMethods,
    ...primaryNavMethods,
    ...shareMethods,
    formatDishes(day) {
      return day.meals
        .map((meal) => {
          return { dishType: 'm', ...meal };
        })
        .concat(
          day.recipes.map((recipe) => {
            return { dishType: 'r', ...recipe };
          })
        )
        .concat(
          day.leftovers.map((leftover) => {
            return { dishType: 'r', mealTime: leftover.mealTime, ...leftover.recipe };
          })
        );
    },
    dayHasDishes(day) {
      return day.meals.concat(day.recipes).length ? true : false;
    },
    dishes(day) {
      const dishes = [];
      const concatDishes = this.formatDishes(day);
      const breakfastDishes = concatDishes.filter((dish) => {
        if (dish.mealTime) {
          return dish.mealTime.name === 'Breakfast';
        }
      });
      const lunchDishes = concatDishes.filter((dish) => {
        if (dish.mealTime) {
          return dish.mealTime.name === 'Lunch';
        }
      });
      const dinnerDishes = concatDishes.filter((dish) => {
        if (dish.mealTime) {
          return dish.mealTime.name === 'Dinner';
        }
      });

      if (breakfastDishes.length) {
        dishes.push([{ mealtime: 'Breakfast' }, breakfastDishes]);
      }

      if (lunchDishes.length) {
        dishes.push([{ mealtime: 'Lunch' }, lunchDishes]);
      }

      if (dinnerDishes.length) {
        dishes.push([{ mealtime: 'Dinner' }, dinnerDishes]);
      }

      return dishes;
    },
    toPlans() {
      this.navigateHigher();
    },
    applyPlatelistToPlan() {
      if (this.selectedPlatelist && this.selectedPlatelist.contentLockStatus && this.selectedPlatelist.contentLockStatus.locked) {
        this.$bvModal.show('redeem-platelist-modal');
      } else {
        this.setUserRequestClearPlan(false);
        this.setUserAction('applyPlatelist');

        const payload = {
          platelistId: this.platelist.id,
          referrerId: this.platelist.profileId,
          startDate: utils.setToMidNight(new Date()).toISOString(),
          overwriteCurrentPlan: true,
        };

        var modalOptions = {
          title: ' ',
          message: `Would you like to apply "${this.platelist.landingpagetitle}" to this week?`,
          okTitle: this.$t('lblYesAddRecipe'),
          cancelTitle: this.$t('lblNoGoBack'),
        };

        if (!this.currentPrimaryView.primary && !this.currentPrimaryView.component === 'Plans') {
          this.keepNavStateButToggleDrawer();
        }

        utils.showConfirmationDialog(this, modalOptions).then(async (response) => {
          if (response === true) {
            this.showLoader(this.$t('lblAddingRecipesToYourWeek'));

            if (this.currentPrimaryView.primary && this.currentPrimaryView.component === 'Plans') {
              this.resetPrimaryStack();
              this.toggleDrawer();
            } else {
              this.setActiveNav({
                title: 'Kitchen Drawer',
                component: 'KitchenDrawerNav',
                isDrawerOpen: false,
              });
            }

            const response = await this.applyPlatelist({ payload, title: this.platelist.title });

            if (response) {
              Leanplum.track('Nutrition', {
                action: 'apply',
                meal_plan_id: this.platelist.id,
                os: 'web',
                platelist_label: this.platelist.title,
              });
              const today = utils.setToMidNight(new Date()).toISOString();
              await this.setDailySummary({
                ...this.dailySummary,
                selectedDate: today.substring(0, today.indexOf('T')), // reset selected day
              });
              await this.getPlanGrid();
              if (this.isPlanEmpty) {
                this.setIsPlanEmpty();
              }
              this.hideLoader();
            } else {
              // TODO: Handle platelist couldn't apply error...
            }
          } else {
            if (!this.currentPrimaryView.primary && !this.currentPrimaryView.component === 'Plans') {
              this.keepNavStateButToggleDrawer();
            }
          }
        });
      }
    },
    prevWeek() {
      if (this.currentWeekOffset > 0) {
        this.currentWeekOffset -= 1;
      }
    },
    nextWeek() {
      if (this.currentWeekOffset < this.numberOfWeeks) {
        this.currentWeekOffset += 1;
      }
    },
    async share() {
      this.shareableLink = this.platelist.sharelink;
      this.setShareableLink(this.platelist.sharelink);

      Leanplum.track('Nutrition', {
        action: 'share',
        meal_plan_id: this.platelist.id,
        os: 'web',
        platelist_label: this.platelist.title,
      });

      setTimeout(() => {
        this.$copyText(this.shareableLink).then(
          (evt) => {
            this.$bvModal.show('copy-clipboard-modal');

            setTimeout(() => {
              this.$bvModal.hide('copy-clipboard-modal');
            }, 3500);
          },
          (evt) => console.log('Could not copy to clipboard.')
        );
      });
    },
  },
  watch: {
    retry(prevVal, newVal) {
      if (this.userAction === 'applyPlatelist') {
        this.applyPlatelistToPlan();
        this.componentKey += 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.plan-detail {
  @extend %scrollable-drawer-content;

  background-color: $color-plan-detail-bg;

  .detail-hero {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    height: 23.7rem;
    justify-content: space-between;
    margin-bottom: 1.6rem;
    padding: 0.8rem;

    .date-select-wrapper {
      padding: 1rem 0 0;

      .date-select {
        align-items: center;
        background-color: $color-plan-detail-hero-date-select-bg;
        border: 1px solid $base-border-color;
        border-radius: $base-border-radius;
        display: flex;
        font-size: 1.3rem;
        justify-content: space-between;
        margin: 0 auto;
        padding: 1rem 2rem;
        width: 16rem;

        h4 {
          font-size: 1.4rem;
          margin-bottom: 0;
        }

        .date-selec-icon {
          color: $color-action;
          font-size: 1.5rem;
        }
      }
    }

    .tag-wrapper {
      display: flex;
      justify-content: space-between;
    }

    .tag {
      align-items: center;
      background-color: $color-meal-card-horizontal-tag-bg;
      border-radius: $base-border-radius - 0.4;
      color: $color-meal-card-horizontal-tag-text;
      display: flex;
      font-size: 1.3rem;
      justify-content: center;
      padding: 0.6rem 1rem;

      .icon-cloche {
        height: 1.68rem;
        margin-right: 0.8rem;
        width: 2rem;
      }

      .icon-calendar {
        height: 1.7rem;
        margin-right: 0.8rem;
        width: 1.6rem;
      }
    }
  }

  .detail-content-container {
    padding: 0 1.6rem 23rem;

    .detail-header {
      margin-bottom: 2rem;

      h1 {
        font-size: 2.4rem;
        line-height: 1;
      }
    }

    .share-btn-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 1rem;
    }

    .detail-section {
      margin-bottom: 3.2rem;

      &:last-of-type {
        margin-bottom: 6.2rem;
      }
    }

    .section-title {
      color: $color-meal-card-horizontal-title;
      font-size: 1.8rem;
      line-height: 2.175rem;
      margin-bottom: 1rem;

      small {
        color: $color-meal-card-horizontal-subtitle;
        display: block;
        font-size: 75%;
      }
    }

    .mealtime-section {
      margin-bottom: 2rem;
    }

    .notice-ended {
      align-items: center;
      display: flex;
      flex-direction: column;

      h2,
      p {
        margin-bottom: 1.4rem;
      }

      p {
        font-size: 1.4rem;
        line-height: 1.3;
        text-align: center;
      }
    }

    .fade-enter-active {
      transition: opacity 0.2s;
    }
    .fade-leave-active {
      transition: opacity 0.2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
  }

  &.screen-lg {
    border-bottom-left-radius: 2.5rem;
    border-bottom-right-radius: 2.5rem;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.3);

    .detail-content-container {
      padding-bottom: 0;
    }
  }
}

.btn-start-plan {
  background-color: $color-plan-detail-cta-button-bg;
  border-radius: $size-plan-detail-apply-btn-border-radius;
  bottom: 3rem;
  box-shadow: $color-plan-detail-cta-button-shadow;
  color: $color-plan-detail-cta-button-text;
  left: calc(50vw - 8rem);
  padding: 1rem 1.5rem;
  position: fixed;
  width: 16rem;

  // iPad Pro
  @include media('xxl', 'ipad-pro') {
    bottom: 12rem;
  }
}
</style>
